import { useAwsImage } from "hooks/awsImage/AwsImage";
import { Fragment, useEffect } from "react";

const PrivateImage = ({ className, privateUrl, imgType, skeleton, onClick, fallback }) => {
    const { data, refetch, isLoading, isError } = useAwsImage(privateUrl, imgType);

    useEffect(() => {
        if (privateUrl !== undefined) {
            refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [privateUrl]);

    if (isError && fallback !== undefined) {
        return fallback;
    }

    return (
        <Fragment>
            {
                !isLoading && privateUrl !== undefined && data !== undefined ?
                    <img className={className} src={data} alt="...." onClick={onClick} /> : <div className={skeleton} ></div>
            }
        </Fragment>
    )
};

export default PrivateImage;
